// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"SA-z","smallCardRow":"TA-z","largeCardRow":"UA-z","productSearchRow":"VA-z","curatedRow":"WA-z"};